import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customer", "contact"]
  static values = {
    url: String,
    emptyLabel: String,
  }

  disconnect() {
    this.abortController?.abort()
  }

  async customerChanged() {
    const customerId = this.customerTarget.value

    this.abortController?.abort()
    this.replaceContacts([])

    if (!customerId) {
      this.contactTarget.disabled = true
      return
    }

    this.contactTarget.disabled = true
    this.abortController = new AbortController()

    try {
      const response = await fetch(
        this.urlValue.replace("__customer_id__", encodeURIComponent(customerId)),
        {
          headers: { Accept: "application/json" },
          signal: this.abortController.signal,
        },
      )

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const data = await response.json()
      this.replaceContacts(data.contacts || [])
      this.contactTarget.disabled = false
    } catch (error) {
      if (error.name === "AbortError") return

      console.error("Could not load opportunity contacts", error)
      this.contactTarget.disabled = false
    }
  }

  replaceContacts(contacts) {
    this.contactTarget.replaceChildren(this.option("", this.emptyLabelValue))

    contacts.forEach((contact) => {
      this.contactTarget.append(this.option(contact.id, contact.name))
    })
  }

  option(value, label) {
    const option = document.createElement("option")
    option.value = value
    option.textContent = label
    return option
  }
}
